import React, { useEffect } from "react";
import Card from "../../components/Card";
import { useAvStore } from "../../store";
import { clickupFormUrl, clickupScriptUrl } from "../../types/config";

export default function BetaFeedbackPage() {
  const user = useAvStore((state) => state.user);
  const clickupSrc = `${clickupFormUrl}?Vendor%2FRetailer%20Name=${user?.businessName}`;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = clickupScriptUrl;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="container">
      <div className="flex items-center justify-between mb-10">
        <h1 className="page-title mb-0">Beta Feedback</h1>
      </div>
      <Card>
        <iframe
          className="clickup-embed clickup-dynamic-height"
          src={clickupSrc}
          onWheel=""
          width="100%"
          height="100%"
          style={{
            height: "1000px",
            background: "transparent",
            border: "1px solid #ccc",
          }}
        ></iframe>
      </Card>
    </div>
  );
}
